import React from 'react';
import { BookingNotificationProps } from './types';
import { NotificationRow } from './NotificationRow';

interface Props extends BookingNotificationProps {
  isLast?: boolean;
  variant?: 'dropdown' | 'sheet';
  onArchive?: () => void;
}

export const BookingNotification: React.FC<Props> = ({
  notification,
  index,
  onClick,
  isLast,
  variant,
  onArchive
}) => {
  const handleClick = () => {
    if (onClick) onClick(notification.bookingId);
  };

  return (
    <NotificationRow
      type={notification.type}
      unread={!notification.read}
      stagger={index}
      isLast={isLast}
      variant={variant}
      onClick={handleClick}
      onArchive={onArchive}
      content={{
        customerName: notification.customerName,
        serviceName: notification.serviceName,
        eventDate: notification.eventDate,
        eventTime: notification.eventTime,
        amount: notification.amount,
        createdAt: notification.createdAt,
        oldEventDate: notification.oldEventDate,
        oldEventTime: notification.oldEventTime,
        newEventDate: notification.newEventDate,
        newEventTime: notification.newEventTime
      }}
    />
  );
};
